<template lang="pug">
.LndContacts
  .__left(v-if="sent")
    h2.--slide-left Message is successfully sent!

  form.__left(v-else, :class="sending && '--sending'", @submit.prevent="onSubmit",
      @input="onFirstInput")
    h2 {{ L.header }}

    ul.d-flex.__addrs.t-miniscroll(v-if="mq.sm")
      address(v-for="addr of L.addrs")
        span(@click="btns[addr.$code] = !btns[addr.$code]")
          | <b>{{ addr.country }}</b> {{ addr.city }}
        p {{ addr.text }}

    fieldset.d-flex.--col.--center(:disabled="sending")
      input(v-model="values.name", placeholder="Your name",
        required)
      input(v-model="values.company", placeholder="Company")
      input(v-model="values.email", placeholder="Email",
        type="email", required)
      textarea(v-model="values.text", placeholder="Your request",
        required, style="min-height: 82px; resize: none;")

      label.d-flex.__consent(for="contacts-consent")
        div(style="width: 64px")
          input(type="checkbox", id="contacts-consent", required, checked)
        div(v-html="L.consent")

      button(type="submit") {{ sending ? 'Sending' : L.submit }}

      p.__ps(v-html="L.ps")

  .__right(v-if="!mq.sm")
    .__map(ref="map")
      //- img(:srcset="`${ mapSrc } 2x`")
      .spot(v-for="addr of L.addrs",
          :class="[addr.$code.toUpperCase(), btns[addr.$code] && '--open']")
        address
          button(@click="btns[addr.$code] = !btns[addr.$code]")
            | <b>{{ addr.country }}</b> {{ addr.city }}
          p {{ addr.text }}

</template>
<script>
import { on } from 'services/emitter';

import GTM from 'services/GTM';
import content from 'content';

export default {
  name: 'LndContacts',

  inject: ['mq'],
  mixins: [
    on({
      resize: 'onResize',
    }),
  ],

  data: () => ({
    sent: false,
    sending: false,

    values: {
      // name: 'test',
      // email: 'test@test.com',
      // company: 'test',
      // text: 'testtesttest',
    },
    btns: {},
  }),

  static: () => ({
    mapSrc: require('assets/imgs/map@2x.png'),
    L: content.contacts,
  }),

  methods: {
    onSubmit () {
      this.sending = true;
      // return setTimeout(() => this.sent = true, 2e3);
      window.fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(this.values),
      }).then(resp => {
        if (resp.status < 400) {
          GTM.onContactFormSubmit();
          this.sent = true;
          return;
        }

        const contentType = resp.headers.get('content-type');
        (contentType.startsWith('application/json') ? resp.json() : resp.text())
          .then(err => window.alert(`Error: \n\n${ err?.message || err }`))
          .finally(() => this.sending = false);
      });
    },

    onResize (mq) {
      this.$nextTick(() => {
        const $map = this.$refs.map;
        if (!$map)
          return;
        $map.style.height = `${ ($map.offsetWidth / 1591) * 632 }px`;
      }, 100);
    },

    onFirstInput (e) {
      if (this.firstInput)
        return;

      this.firstInput = true;
      GTM.onContactFirstInput();
    },
  },

  mounted () {
    this.onResize();
  },
};

</script>
<style>
.LndContacts {
  display: flex;
  height: 100%;
  /*padding: calc(var(--page-pad) + var(--topb-h)) 0 var(--page-pad);*/

  .__left {
    position: relative;
    z-index: 3;

    &:after {
      position: absolute;
      top: calc(-1 * var(--topb-h) - var(--page-pad));
      right: 0;
      bottom: calc(-1 * var(--page-pad));
      z-index: -1;

      display: block;
      width: 9999px;
      /*height: 100vh;*/

      background: #010b1e8a;
      box-shadow: 0 0 130px -30px black;

      content: '';
    }
  }

  .__right {
    --pad: calc(48 / var(--vw-scale));

    position: relative;

    display: flex;
    align-items: center;
    justify-content: center;
    width: calc(100% + var(--page-pad));
    margin-right: calc(-1 * var(--page-pad));
    padding-left: var(--pad);
    padding-right: var(--pad);
    /*width: calc(100% - 2 * var(--page-pad));*/


/*    &:after {
      position: absolute;
      top: calc(-1 * var(--topb-h) - var(--page-pad));
      bottom: calc(-1 * var(--page-pad));
      left: 0;

      display: block;
      width: 9999px;

      background-color: rgba(239, 243, 247, 0.85);

      content: '';
    }*/
  }

  .__map {
    --pspc: 1000px;
    --o-w: 1591;
    --o-h: 632;
    --asp: calc(var(--o-w) / var(--o-h));

    position: relative;
    top: -2vh;
    z-index: 1;

    width: 100%;
    /*height: calc(100% / var(--asp));*/

    background-image: url('~assets/imgs/map@1.5x.png');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;

    .spot {
      --bg-c: #394c6f;
      --s: 10px;
      --ext-s: 20px;

      position: absolute;
      /*z-index: 1;*/

      width: var(--s);
      height: var(--s);

      background: var(--text-c);
      border-radius: 50%;

      &:before {
        position: absolute;
        top: calc(-.5 * var(--ext-s) + var(--s) / 2);
        left: calc(-.5 * var(--ext-s) + var(--s) / 2);

        display: block;

        width: var(--ext-s);
        height: var(--ext-s);

        border-radius: 50%;
        box-shadow: 0 0 0 1px var(--text-c);
        opacity: 0;

        transition: all .2s;

        content: '';
      }
    }

    address {
      position: absolute;

      min-width: 200px;

      perspective: var(--pspc);

      > * {
        padding: 0 12px;

        background: var(--bg-c);
      }

      button {
        display: block;
        margin-bottom: 12px;

        color: inherit;
        line-height: 38px;
        white-space: nowrap;

        border: none;
      }

      p {
        display: block;
        padding: 24px 12px;

        color: inherit;
        font-size: 12px;
        line-height: 18px;
        white-space: break-spaces;

        box-shadow: 2px 4px 15px -5px var(--black-50);
        transform: translateY(-40px) translateZ(-230px);
        transform-origin: top;
        opacity: 0;

        transition: all .2s;

        /*perspective: 1000;*/
        pointer-events: none;
      }

    }

    .spot.--open {
      p {
        z-index: 5;

        transform: translateY(0);
        opacity: 1;

        pointer-events: initial;
      }
    }

    .spot.--open:before {
      opacity: 1;

      animation: 2s linear infinite normal both k-spot-rot3d;
    }

    .NL {
      top: 17%;
      left: 50%;

      perspective: var(--pspc);

      button {
        box-shadow: 16px 8px 15px -5px var(--black-50);
      }

      address {
        top: -20px;
        right: 25px;

        /*transform: rotate3d(.01,-.005,0, 25deg)*/
      }
    }

    .CY {
      top: 30%;
      left: 54%;

      button {
        box-shadow: 6px 10px 15px -5px var(--black-50);
      }

      perspective: var(--pspc);

      address {
        top: -40px;
        left: 25px;

        /*transform: skewX(3deg);*/
        /*transform: rotate3d(.005, .001, .001, 19deg);*/
      }
    }

    .AU {
      top: 83%;
      left: 97%;

      perspective: var(--pspc);

      button {
        box-shadow: 3px 3px 15px -5px var(--black-50);
      }

      address {
        top: 21px;
        right: 25px;

        /*transform: rotate3d(1, -1, .2, 345deg);*/

      }
    }
  }

  .--slide-left {
    --k-slide-from-y: -50px;
    animation: .6s k-slide both, .8s k-opac ease-out both;
  }

  p,
  label {
    color: #677b8c;
  }

  .__ps {
    margin-top: 5px;

    font-weight: 400;
    font-size: 14px;
    line-height: 148.41%;
    letter-spacing: -0.065em;
  }

  .__consent {
    font-size: 9px;
    line-height: 13px;
  }

  a,
  a:visited {
    color: var(--white-50);
    text-decoration: underline;
  }

  address {
    font-style: normal;
  }

  h2 {
    margin-bottom: 28px;
  }

  img { width: 100% }

  form {
    --gap-v: 20px;

  }

  form.--sending {
    input,
    textarea,
    button {
      background: rgba(255, 255, 255, .3);
    }

    [type="submit"]:after {
      position: absolute;

      white-space: nowrap;

      animation: .5s linear infinite k-spinner-dots;

      content: '...';
    }

    @keyframes k-spinner-dots {
      0% { content: '.  ' }
      33% { content: ' . ' }
      66% { content: '  .' }
      100% { content: '.  ' }
    }
  }


  input:not([type="checkbox"]),
  textarea,
  button {
    width: 100%;
    min-height: 41px;
    padding: 4px var(--input-p);

    color: var(--input-c);
    font: var(--input-font);
    line-height: 28px;

    background: transparent;
    border: 1px solid var(--sep-c);
    outline: none;

    transition: all .2s;

    &:focus,
    &:active {
      border-radius: 2px;
      box-shadow: 0 0 0 3px var(--border-c);
    }

    &::placeholder {
      color: var(--input-c);
    }
  }

  input {
    height: var(--input-h);
  }

  form button {
    color: var(--white);

    &:hover {
      background-color: #677b8c;
    }
  }
}

@keyframes k-spot-rot3d {
/*  0% { transform: rotate3d(1, 1, 1, 0); }
  50% { transform: rotate3d(1, 1, 1, 180deg); }
  100% { transform: rotate3d(1, 1, 1, 360deg); }*/
  0% { transform: rotateZ(33deg) rotateX(0deg) rotateY(0deg) }
  /*50% { transform: rotateZ(0deg) rotateX(0deg) rotateY(0deg) }*/
  100% { transform: rotateZ(393deg) rotateX(360deg) rotateY(360deg) }
}

@media (min-width: 740px) {
  .LndContacts {
    .__left {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: max(480 / var(--vw-scale), 320px);
      padding-right: calc(100 / var(--vw-scale));
    }
  }
}

@media (max-width: 739px) {
  .LndContacts {
    padding-bottom: 30px;

    .__left {
      /*overflow: hidden;*/

      fieldset {
        width: max(480 / var(--vw-scale), 320px);
      }

      &:after {
        display: none;
      }
    }

    .__addrs {
      --gap-h: 24px;
      position: relative;

      width: 100vw;
      margin: 50px calc(-1 * var(--page-pad));
      padding: 0 var(--page-pad) var(--page-pad);
      margin-bottom: 16px;

      overflow-x: auto;
      overflow-x: overlay;
      scroll-snap-type: x mandatory;

      > * {
        scroll-snap-align: center;

        width: 230px;
      }

      address {
        flex-shrink: 0;
        padding: 30px 16px;

        background: var(--bg-c);

        span {
          display: block;
          margin-bottom: 50px;
        }
        p {
          color: inherit;
          font-size: 12px;
          line-height: 19px;
        }
      }
    }
  }
}
</style>
